import styled, { css } from 'styled-components';
import { getContrastText } from 'react-rainbow-components/styles/helpers/color';

export const BadgeContainer = styled.div<{ color: string; variant?: 'default' | 'solid' }>`
    display: inline-flex;
    align-items: center;
    align-self: flex-end;
    color: ${(props) => props.color};
    background: ${(props) => `${props.color}29`};
    text-transform: capitalize;
    
    padding: 0.1875rem 0.375rem;
    border-radius: 0.25rem;
    gap: 0.625rem;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    line-height: 0.875rem;

    ${(props) => props.variant === 'solid' && props.color && css`
        color: ${getContrastText(props.color)};
        background: ${props.color};
    `};
`;
